{
  "slug": "iq-vs-intelligence",
  "title": "QI vs intelligence: sont-ils la même chose?",
  "description": "Comprendre la différence entre un score de QI standardisé et le concept plus large de l'intelligence humaine.",
  "summary": "L’intelligence est un concept psychologique large, le QI est une estimation normalisée basée sur la performance dans certaines tâches cognitives.",
  "sections": [
    {
      "heading": "L’intelligence est plus large qu’un score",
      "paragraphs": [
        "Les psychologues utilisent l'intelligence pour parler de la capacité d'apprendre, de raisonner, de résoudre des problèmes, de s'adapter et d'utiliser les connaissances.Les théories diffèrent: certaines mettent l'accent sur un facteur général, tandis que d'autres décrivent plusieurs capacités larges ou spécialisées.",
        "L’intelligence fonctionne dans des environnements réels, où les connaissances pratiques, la créativité, la persévérance et l’expérience culturelle façonnent la façon dont les gens résolvent des problèmes significatifs."
      ]
    },
    {
      "heading": "Le QI est un outil de mesure",
      "paragraphs": [
        "Un score de QI résume un échantillon de performance cognitive par rapport à un groupe de normes basé sur l'âge.Des tests bien conçus peuvent prédire certains résultats éducatifs et professionnels, mais la prédiction est statistique plutôt que destinée.",
        "Les tâches, les scores, les normes, le langage et les conditions de test définissent ce qu’un résultat peut supporter, et ce qui ne peut pas être supporté."
      ]
    },
    {
      "heading": "Utilisez la note au bon niveau",
      "paragraphs": [
        "Le QI est utile lorsque la question correspond aux données probantes, comme pour décrire les schémas de forces et de besoins cognitifs dans une évaluation complète, mais il est moins utile comme abréviation pour le talent, le caractère, la créativité ou la valeur.",
        "Une interprétation réfléchie combine les scores avec l'historique, le comportement, l'environnement, les objectifs et d'autres informations pertinentes."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Le QI mesure-t-il toute l'intelligence?",
      "answer": "Non, il échantillonne des capacités cognitives importantes, mais n’épuise pas la créativité, le jugement pratique, la sagesse, la motivation ou les compétences émotionnelles."
    },
    {
      "question": "Quelqu'un peut-il être intelligent avec un QI moyen?",
      "answer": "Un composite moyen peut coexister avec des forces spécifiques, une expertise, une créativité ou une résolution de problèmes pratique efficace."
    }
  ],
  "related": ["what-is-iq", "iq-vs-eq", "how-is-iq-measured"]
}
